import { FC } from 'react'
import Contractor from '../../../../../../../../components/form-items/contractor/contractor'
import { requiredRules } from '../../../../../../../../constants/forms/validation/rules'

interface SupplierProps {}

const Supplier: FC<SupplierProps> = () => {
    const name = 'supplier'

    return (
        <Contractor
            name={name}
            label={'Поставщик'}
            typeName={'Поставщик материала'}
            rules={requiredRules}
        />
    )
}

export default Supplier
